// extracted by mini-css-extract-plugin
export var menu = "menu-module--menu--d_JCx";
export var submenu = "menu-module--submenu--3cve9";